import { useEffect, useState } from "react";
import { MoveIcon } from "../../../assets/icons";
import { Button } from "../../../components/button/button";
import { Image } from "../../../components/image/image";
import { useOpenPage } from "../../../hooks/useOpenPage";
import { useSortable } from "@dnd-kit/sortable";

import styles from "./adminKnowledgeBasePage.module.css";
import KnowledgeAPI from "../../../api/KnowledgeAPI";

import { Text } from "../../../components/text/text";

export const KnowledgeButton = ({ text, imgSrc, link, id }) => {
    const { attributes, listeners, setNodeRef, transform } = useSortable({
        id: id
    });

    const openPage = useOpenPage();

    const [photo, setPhoto] = useState(null);
    useEffect(() => {
        if (!imgSrc) return;
        KnowledgeAPI
            .fetchMaterialIconURL(imgSrc)
            .then(setPhoto)
            .catch(console.error);
    }, [imgSrc]);

    return (
        <div
            ref={setNodeRef}
            {...attributes}
            style={{
                transform: transform ? `translate(${transform.x}px, ${transform.y}px)` : undefined
            }}
        >
            <div className={styles.knowledge_button_container}>
                <Button
                    onClick={openPage(link)}
                    className={styles.knowledge_button}
                    text={
                        <div className={styles.line_style}>
                            {
                                imgSrc &&
                                <Image className={styles.image} width="24px" height="30px" src={photo} />
                            }
                            <Text tag="span" view="body" className={styles.text_style} size={14} weight={700} lineHeight="1.1">{text}</Text>
                        </div>}
                    icon={<MoveIcon />}
                    type="secondary"
                />
                <div className={styles.dnd_listener} {...listeners} />
            </div>
        </div>
    )
}